module.exports = __webpack_public_path__ + "img/2f_r_tonya@2x.3963014f.jpg";